import styled from "@emotion/styled";
import * as React from "react";
import {useCallback, useRef, useState} from "react";

import {
    ImageUploadInput,
    ImageUploadInputRef,
} from "../template-detail-image-upload-input/template-detail-image-upload-input";
import {IMAGE_CONVERT_TYPE_GENERAL_CONTENT_IMAGE} from "../template-detail-image-upload-input/template-detail-upload-image";
import {UploadImageResult} from "../template-detail-image-upload-input/template-detail-upload-image";

const UploadStatusUploading = styled.span`
    display: inline-block;
    box-sizing: border-box;
    width: 12px;
    height: 12px;
    border-radius: 50%;
    font-size: 4px;
    position: relative;
    border-top: 1.1em solid rgba(0, 0, 0, 0.2);
    border-right: 1.1em solid rgba(0, 0, 0, 0.2);
    border-bottom: 1.1em solid rgba(0, 0, 0, 0.2);
    border-left: 1.1em solid #ffffff;
    transform: translateZ(0);
    animation: load8 1.1s infinite linear;
    @keyframes load8 {
        0% {
            transform: rotate(0deg);
        }
        100% {
            transform: rotate(360deg);
        }
    }
`;

type ImageUploadStatus = "normal" | "uploading" | "error";

export interface TemplateDetailImageUploadButtonProps {
    imageConvertType?: string;
    onUploading?: () => void;
    onUploaded?: (uploadImageResult: UploadImageResult) => void;
    fieldId: string;
}
export const TemplateDetailImageUploadButton: React.FC<TemplateDetailImageUploadButtonProps> = ({
    imageConvertType,
    onUploading,
    onUploaded,
    fieldId,
}) => {
    const imageInputRef = useRef<ImageUploadInputRef>(null);

    const [status, setStatus] = useState<ImageUploadStatus>("normal");

    const onSelectButtonClick = useCallback((e: React.MouseEvent<HTMLButtonElement>) => {
        e.preventDefault();

        imageInputRef.current?.startUpload();
    }, []);

    const onInputUploading = useCallback(() => {
        setStatus("uploading");
        onUploading?.();
    }, [onUploading]);

    const onInputUploaded = useCallback(
        (result: UploadImageResult) => {
            if (result.status === "success") {
                setStatus("normal");
                onUploaded?.(result);
            } else {
                console.error(result.error);
                setStatus("error");
            }
        },
        [onUploaded],
    );
    return (
        <>
            <button
                onClick={onSelectButtonClick}
                type="button"
                style={{minWidth: "100px"}}
                disabled={status !== "normal"}
            >
                {status === "uploading" ? <UploadStatusUploading /> : "アップロード"}
            </button>
            <ImageUploadInput
                ref={imageInputRef}
                onUploading={onInputUploading}
                onUploaded={onInputUploaded}
                fieldId={fieldId}
                imageConvertType={imageConvertType ?? IMAGE_CONVERT_TYPE_GENERAL_CONTENT_IMAGE}
            />
        </>
    );
};
